import { Component } from '@verndale/core'

class jumpLinks extends Component {
  setupDefaults() {
    this.dom = {
      $sectionsData: Array.from(this.el.parentNode.querySelectorAll('[data-section]')),
      $jumpLinks: this.el.querySelector('.jump-links'),
      $images: this.el.parentNode.querySelectorAll('img')
    }

    this.dom.$sectionsData = this.dom.$sectionsData.reduce((array, obj) => {
      if (obj.dataset.section) array.push(obj)
      return array
    }, [])

    this.setObserver()
    this.scrollTo = ''
    this.insertSections()
  }

  setObserver() {
    const offsetTopPercentage = (this.el.offsetHeight * 100) / window.innerHeight + 3
    const offsetBottomPercentage = 94 - offsetTopPercentage
    const options = {
      root: null,
      threshold: 0.001,
      rootMargin: `-${offsetTopPercentage}% 0% -${offsetBottomPercentage}%`
    }
    this.observer = new IntersectionObserver((entries) => this.handleOnIntersect(entries), options)
  }

  addListeners() {
    this.dom.$jumpLinks.addEventListener('click', (e) => this.handleClick(e))
    this.dom.$images.forEach((image) => image.addEventListener('load', (e) => this.scrollBy(e)))
  }

  scrollBy(e) {
    if (this.scrollTo) {
      this.scrollToSection(this.scrollTo)
    }
  }

  insertSections() {
    this.dom.$jumpLinks.innerHTML = ''
    const cloneJumpLinks = this.dom.$jumpLinks.cloneNode(true)

    this.dom.$sectionsData.forEach((section) => {
      const id = section.dataset.section.split(' ').join('')
      section.setAttribute('id', `${id}`)
      this.observer.observe(section)
      cloneJumpLinks.innerHTML += `<li><a class='jump-links__link' href="#${id}">${section.dataset.section}</a></li>`
    })
    this.dom.$jumpLinks.innerHTML = cloneJumpLinks.innerHTML

    this.navJumpLink = this.el.querySelectorAll('.jump-links__link')
  }

  handleOnIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const entryId = entry.target.closest('[data-section]').id
        this.navJumpLink.forEach((item) => item.classList.remove('jump-links__link--active'))
        const jumplinkIndex = Array.from(this.navJumpLink).findIndex(
          (x) => x.getAttribute('href') === `#${entryId}`
        )
        this.navJumpLink[jumplinkIndex].classList.add('jump-links__link--active')
        if (this.scrollTo === entryId) {
          this.scrollTo = '';
        }
      }
    })
  }

  handleClick(e) {
    if (e.target.classList.contains('jump-links__link')) {
      e.preventDefault()
      const id = e.target.getAttribute('href').substring(1)
      this.scrollTo = id
      this.scrollToSection(id);
    }
  }

  scrollToSection(id) {
    const offset = this.el.offsetHeight
    const target = Array.from(this.dom.$sectionsData).find((x) => x.id === id)?.offsetTop - offset
    window.scroll({
      top: target-66,
      behavior: 'smooth'
    })

  }
}

export default jumpLinks
